"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockedQueryBuilder = exports.mockedPaginatedCollectionBuilder = void 0;
const mockedPaginatedCollectionBuilder = (options) => {
    const { nodes, pageInfo, totalCount, pageIndex = 0, typename } = options;
    return {
        nodes: nodes,
        pageInfo: Object.assign({ hasNextPage: false, hasPreviousPage: false, startCursor: 'MQ', endCursor: 'NA', __typename: 'PageInfo' }, pageInfo),
        totalCount: totalCount !== null && totalCount !== void 0 ? totalCount : nodes.length,
        pageIndex: pageIndex,
        __typename: typename
    };
};
exports.mockedPaginatedCollectionBuilder = mockedPaginatedCollectionBuilder;
const mockedQueryBuilder = (options) => {
    const { query, variables, result, error } = options;
    return {
        request: {
            query,
            variables
        },
        error,
        result
    };
};
exports.mockedQueryBuilder = mockedQueryBuilder;
